import type { Messages } from "../catalogue.en";

/**
 * Patients: the registry and the patient card.
 *
 * Composed into the public catalogue by `catalogue.he.ts`. Nothing imports
 * this module directly: consumers ask the catalogue, so how the messages are
 * stored stays this layer's business.
 */
export const patients: Partial<Messages> = {
  "patient.documents.nationalType": "סוג מסמך במילון",
  "patient.documents.nationalPolicyType": "סוג פוליסה במילון",
  "patient.documents.insurerCoding": "מבטח במילון",
  "patient.documents.searchCoding": "חיפוש במילון פרופיל המרפאה",
  "patient.documents.clearCoding": "הסרת בחירה מהמילון",



  "patient.curator.edit": "שינוי מלווה",
  "patient.curator.title": "מלווה",
  "patient.curator.none": "לא הוגדר מלווה",
  "patient.curator.loading": "טעינת המלווה",
  "patient.curator.notFound": "המטופל לא נמצא.",
  "patient.curator.unsaved": "מינוי מלווה שלא נשמר",
  "patient.curator.cycle": "המינוי ייצור מעגל של מלווים.",
  "patient.curator.ineligible": "ניתן למנות כמלווה רק רופא פעיל במרפאה זו.",
  "patient.curator.stale": "המלווה השתנה בחלון אחר. טענו מחדש את המינוי.",
  "patient.curator.failed": "לא ניתן לטעון או לשמור את המלווה. נסו שוב.",

  "patients.title": "מטופלים",
  "patients.loading": "טוען מטופלים",
  "patients.tableLabel": "רשימת מטופלים",
  "patients.resultCountOne": "מטופל אחד",
  "patients.resultCountMany": "{count} מטופלים",
  "patients.matchCountOne": "מטופל תואם אחד",
  "patients.matchCountMany": "{count} מטופלים תואמים",
  "patients.columnPatient": "מטופל",
  "patients.columnCode": "קוד",
  "patients.columnBirthDate": "תאריך לידה",
  "patients.columnSex": "מין",
  "patients.columnStatus": "סטטוס",
  "patients.columnUpdated": "עודכן",
  "patients.columnExternalSystems": "מערכות חיצוניות",
  "patients.columnAcquisition": "שיוך הגעה",
  "patients.filterTestPatients": "מטופלי טסט",
  "patients.filterRealPatients": "מטופלים אמיתיים",
  "patients.filterVipPatients": "מטופלי VIP",
  "patients.filterRegularPatients": "מטופלים רגילים",
  "patients.filterKindGroup": "סוג רשומה",
  "patients.filterVipGroup": "מעמד VIP",
  "patients.birthFrom": "נולדו מתאריך",
  "patients.birthTo": "נולדו עד תאריך",
  "patients.updatedFrom": "עודכנו מתאריך",
  "patients.updatedTo": "עודכנו עד תאריך",
  "patients.columnActions": "פעולות",
  "patients.cardNamed": "פתיחת כרטיס המטופל {name}, {code}",
  "patients.selectNamed": "בחירת {name}, {code}",
  "patients.matchedFormerName": "התאמה לשם קודם",
  "patients.selectedPatient": "המטופל הנבחר",
  "patients.openCard": "פתיחת כרטיס המטופל",
  "patients.empty": "אין עדיין מטופלים",
  "patients.emptyDetail": "מטופלים הרשומים במרפאה יופיעו כאן.",
  "patients.birthDateInvalid": "תאריך הלידה אינו תאריך תקין.",
  "patients.criterionRefused":
    "השרת דחה אחד מביטויי החיפוש האלה. ערוך אותו כדי לטעון את הרשימה מחדש.",
  "patients.noMatches": "אין מטופלים התואמים למסננים",
  "patients.noMatchesDetail":
    "התאם את מסנני העמודות, או נקה אותם כדי לראות את כולם.",
  "patients.loadFailed": "לא ניתן היה לטעון את המטופלים",

  "patient.code": "קוד מטופל",
  "patient.birthDate": "תאריך לידה",
  "patient.acquisition": "מקור הגעת המטופל",
  "patient.acquisition.kind.clinic": "מרפאה",
  "patient.acquisition.kind.practitioner": "מטפל",
  "patient.acquisition.kind.referralPartner": "שותף הפניה",
  "patient.acquisition.unresolved": "מקור ישן שלא זוהה",
  "patient.acquisition.capture": "אופן קליטה",
  "patient.acquisition.capture.manual": "ידני",
  "patient.acquisition.capture.onboardingLink": "קישור קליטה",
  "patient.acquisition.capture.module": "מודול חיצוני",
  "patient.acquisition.capture.migration": "הסבת נתונים ישנים",
  "patient.acquisition.capture.correction": "תיקון",
  "patient.acquisition.option": "{kind}: {name}",
  "patient.acquisition.select": "בחירת מקור",
  "patient.acquisition.loading": "המקורות נטענים…",
  "patient.acquisition.loadFailed": "לא ניתן היה לטעון את מקורות ההגעה.",
  "patient.acquisition.correctionReason": "סיבה לשינוי מקור ההגעה",
  "patient.acquisition.required": "יש לבחור מקור הגעה.",
  "patient.rowDescription": "{code}, {birth}",
  "patient.administrativeSex": "מין",
  "patient.sex.female": "נקבה",
  "patient.sex.male": "זכר",
  "patient.status.active": "פעיל",
  "patient.status.archived": "בארכיון",
  "patient.status.merged": "ממוזג",
  "patient.registration": "רישום",
  "patient.link.replaced-by": "הוחלף על ידי",
  "patient.link.replaces": "מחליף",
  "patient.preferredLanguage": "שפה מועדפת",
  "patient.titleSheetSubtitle":
    "הרשומה האזרחית והמנהלית שהמרפאה מחזיקה עבור מטופל זה. ממצאים קליניים נמצאים בחלקים האחרים של התיק.",
  "recent.title": "נפתחו לאחרונה",
  "recent.kindPatients": "מטופלים",
  "recent.kindEncounters": "מפגשים",
  "recent.kindExternalEntries": "רשומות חיצוניות",
  "recent.openPatient": "פתיחת התיק של {name}",
  "recent.openEncounter": "פתיחת המפגש עם {name}",
  "recent.openExternalEntry": "פתיחת הרשומה החיצונית של {name}",
  "recent.star": "הוספת {name} למועדפים",
  "recent.unstar": "הסרת {name} מהמועדפים",
  "recent.forget": "הסרת {name} מרשימת הפריטים שנפתחו לאחרונה",
  "recent.ribbonTitle": "מטופלים שנפתחו לאחרונה",
  "recent.openCard": "פתיחת הרשומות הרפואיות של {name}, {code}",
  "patient.contextLoading": "טוען מטופל…",
  "patient.contextUnavailable": "פרטי המטופל אינם זמינים.",
  "patient.notFound": "המטופל לא נמצא",
  "patient.notFoundDetail": "מטופל זה אינו קיים במרפאה שלך.",
  "patient.citizenship": "אזרחות",
  "patient.countryOfResidence": "ארץ מגורים",
  "patient.ageYears": "בני {years}",
  "patient.ageYearsMonths": "{years} שנים {months} חוד׳",
  "patient.ageMonths": "{months} חודשים",
  "patient.birthDateInvalid": "תאריך הלידה נדחה. הוא אינו יכול להיות בעתיד.",
  "patient.unsavedIntent": "פרטי המטופל",

  // The practitioner's own mark as a register REPORTS it, from the same word
  // the tray's two acts use. Opens with a Hebrew word, like every value here,
  // so the first strong character keeps the line right-to-left inside `bdi`.
  "patient.favouriteBadge": "מטופל מועדף",
  // "VIP" is this product's Hebrew vocabulary for the classification, kept in
  // Latin as printed. Every value opens with a Hebrew word so the first strong
  // character keeps the line right-to-left inside `bdi`.
  "patient.vipBadge": "מטופל VIP",
  // "טסט" is the word the clinic's own staff use for a test record; "בדיקה"
  // would read as a medical examination on a chart. Every value opens with a
  // Hebrew word so the first strong character keeps the line right-to-left.
  "patient.testBadge": "מטופל טסט",
  "patient.testChip": "טסט",
  "patientVip.mark": "סמן כ-VIP",
  "patientVip.unmark": "הסר סטטוס VIP",
  "patientVip.staleRevision":
    "סטטוס ה-VIP השתנה במקום אחר. הסטטוס הנוכחי מוצג כעת; בדוק אותו לפני שינוי נוסף.",
  "patientVip.failed": "לא ניתן היה לשנות את סטטוס ה-VIP. נסה שוב.",

  "patientPicker.favouriteGroup": "מטופלים מועדפים",
  "patientPicker.recentGroup": "נצפו לאחרונה",
  "patientPicker.allGroup": "כל המטופלים",
  "patientPicker.placeholder": "לא נבחר מטופל",
  "patientPicker.noMatches": "אין מטופל מתאים",
  "patientPicker.loadFailed": "לא ניתן היה לטעון את המטופלים.",

  "patientMerge.open": "מיזוג כפילות",
  "patientMerge.title": "מיזוג מטופל כפול",
  "patientMerge.description":
    "הכרטיס שנבחר יישאר פעיל. כרטיס זה יסומן כמוחלף; ההיסטוריה הקלינית הקיימת שלו תישאר תחת הפניית המטופל המקורית.",
  "patientMerge.target": "המטופל שיישאר",
  "patientMerge.reason": "הערת סיבה (לא חובה)",
  "patientMerge.checkingTarget": "בודק את המטופל שנבחר…",
  "patientMerge.targetUnavailable": "המטופל שנבחר אינו זמין עוד.",
  "patientMerge.cancel": "ביטול",
  "patientMerge.confirm": "מיזוג מטופל",
  "patientMerge.merging": "ממזג…",
  "patientMerge.staleRevision":
    "אחד המטופלים השתנה. בחר שוב את המטופל שיישאר לפני המיזוג.",
  "patientMerge.keyConflict":
    "טופס המיזוג הזה כבר שימש למטופל אחר. סגור אותו והתחל מחדש.",
  "patientMerge.targetNotActive":
    "המטופל שאמור להישאר אינו פעיל עוד. בחר מטופל אחר.",
  "patientMerge.notFound": "אחד המטופלים אינו זמין עוד.",
  "patientMerge.rejected":
    "המיזוג נדחה כפי שהוזן. בדוק את המטופל שנבחר ונסה שוב.",
  "patientMerge.failed": "לא ניתן היה למזג את המטופלים. נסה שוב.",

  "patientRegistration.title": "מטופל חדש",
  "patientRegistration.detail":
    "קוד המטופל מוקצה על ידי המרפאה בעת יצירת הכרטיס. כל שאר הפרטים ניתנים לעריכה לאחר מכן בדף הכותרת.",
  "patientRegistration.submit": "רישום מטופל",
  "patientRegistration.submitting": "רושם…",
  // Every value opens with a Hebrew word, so the first strong character keeps
  // the line right-to-left; "טסט" is the staff's own word for a test record.
  "patientRegistration.testPatient": "רישום כמטופל טסט",
  "patientRegistration.testPatientHint":
    "תיק סינתטי להדגמה ולבדיקות. הוא נושא את התווית ׳טסט׳ בכל מקום שבו הוא מוצג.",
  "patientRegistration.testConfirmTitle": "לשמור כמטופל טסט?",
  "patientRegistration.testConfirmDetail":
    "התיק ייווצר כמטופל טסט, ולא ניתן יהיה להסיר את הסימון לאחר מכן. אדם אמיתי יש לרשום בלעדיו.",
  "patientRegistration.testConfirmSave": "שמירה כמטופל טסט",
  "patientRegistration.testConfirmFix": "חזרה לתיקון",
  "patientRegistration.unsavedDetail":
    "פעולה זו תבטל את המטופל שהזנת. לא נוצר כרטיס.",
  "patientRegistration.unsavedIntent": "מטופל חדש",
  "patientRegistration.keyConflict":
    "הפרטים אינם תואמים למטופל שכבר נרשם בטופס זה. סגור את הלוח והתחל טופס חדש.",
  "patientRegistration.codeExhausted":
    "למרפאה לא נותרו קודי מטופל. דבר לא נוצר; פנה למנהל.",
  "patientRegistration.rejected":
    "המטופל נדחה כפי שהוזן. בדוק את השדות ונסה שוב.",
  "patientRegistration.failed": "לא ניתן לרשום את המטופל. נסה שוב.",
  "patientCard.workspaceLabel": "כרטיס מטופל",
  "patientCard.menuLabel": "מקטעי כרטיס המטופל",
  "patientCard.tabRecords": "רשומות רפואיות",
  "patientCard.tabRecordsDescription": "מפגשים, רשומות והפניות",
  "patientCard.tabCases": "תיקים",
  "patientCard.tabCasesDescription": "פרקי הטיפול שהעבודה משויכת אליהם",
  "patientCard.tabFiles": "קבצים",
  "patientCard.tabFilesDescription": "מסמכים ותמונות",
  "patientCard.tabMessages": "הודעות",
  "patientCard.tabMessagesDescription": "התכתבות עם המטופל",
  "patientCard.tabStay": "אשפוזים",
  "patientCard.tabStayDescription": "אשפוזים מתוכננים ורשומים",
  "patientCard.tabSchedule": "זמינות",
  "patientCard.tabScheduleDescription": "זמינות וזמן לא זמין",
  "patientCard.tabTasks": "משימות המרפאה",
  "patientCard.tabTasksDescription":
    "עבודת מרפאה פתוחה ומושלמת המקושרת למטופל זה",
  "patientCard.tasksTitle": "משימות המרפאה",
  "patientCard.tasksEmpty": "אין משימות מרפאה המקושרות למטופל זה",
  "patientCard.tasksEmptyDetail":
    "משימות המרפאה המקושרות אל {name} יופיעו כאן.",
  "patientCard.tabFinance": "כספים",
  "patientCard.tabFinanceDescription": "אומדני טיפול והקשר חשבון",
  "patientCard.tabLaboratory": "תוצאות מעבדה וסימנים חיוניים",
  "patientCard.tabLaboratoryDescription":
    "תוצאות, סימנים חיוניים, מגמות וקובצי דוחות",
  "patientCard.tabImaging": "הדמיה",
  "patientCard.tabImagingDescription": "מחקרי CT ו-MRI מאוחסנים",
  "patientCard.tabTitleSheet": "דף כותרת",
  "patientCard.tabTitleSheetDescription": "זהות ופרטים מנהליים",
  "patientCard.tabMedical": "דף כותרת רפואי",
  "patientCard.tabMedicalDescription": "אבחנות, מדדים עיקריים וסיכום המטופל",

  "patient.documents.previewBlank": "תצוגה מקדימה של הטופס",
  "patient.documents.issueLink": "הנפקת קישור לחתימה",
  "patient.documents.sendLink": "שליחת הקישור",
  "patient.documents.deliveryFailed": "השליחה נכשלה או אינה זמינה. יש להעתיק את הקישור ולהעבירו למטופל.",
  "patient.documents.deliveryQueued": "התבקשה שליחת הקישור.",
  "patient.documents.sendTo": "לאן לשלוח",
  "patient.documents.sendAllChannels": "לכל הערוצים המורשים",
  "patient.documents.noChannels": "אין ערוצים מורשים לתקשורת.",
  "patient.documents.linkExpires": "יפוג {when}",
  "patient.documents.linkExpired": "תוקף הקישור פג",
  "patient.documents.linkIssued": "הקישור הונפק",
  "patient.documents.linkHidden": "הכתובת מוצגת רק בעת ההנפקה; להעתקה יש להנפיק קישור חדש.",
  "patient.documents.noLink": "לא הונפק קישור",
  "patient.documents.revokeReason": "סיבת ביטול ההסכמה",
  "patient.documents.revoke": "ביטול הסכמה",
  "patient.documents.uploadSigned": "העלאת הסכמה חתומה",
  "patient.documents.submitReview": "העברה לבדיקה במרפאה",
  "patient.documents.title": "מסמכים",
  "patient.documents.forbidden": "לחשבון הזה אין הרשאה לקרוא מסמכי מטופל.",
  "patient.documents.loading": "טוען מסמכים…",
  "patient.documents.failed": "לא ניתן לטעון את אזור המסמכים.",
  "patient.documents.downloadFailed": "לא ניתן להוריד את המסמך.",
  "patient.documents.identifierExists": "המזהה כבר רשום. אפשר לתקן את הרשומה הקיימת או לצרף אליה סריקות.",
  "patient.documents.correctIdentifier": "פתיחת הרשומה הקיימת",
  "patient.documents.replaceIdentifierDraft": "לבטל את הטיוטה ולפתוח את רשומת המזהה הקיימת? אם הטעינה תיכשל, הטיוטה תישאר פתוחה.",
  "patient.documents.commandFailed": "לא ניתן להשלים את פעולת המסמך. נסו שוב.",
  "patient.documents.downloadForbidden": "לחשבון הזה אין הרשאה להוריד מסמכי מטופל.",
  "patient.documents.downloadGone": "הקובץ הזה אינו נשמר עוד. יש לרענן את האזור.",
  "patient.documents.downloadUnavailable": "אחסון המסמכים לא נענה. יש לנסות להוריד שוב בהמשך.",
  "patient.documents.createFailed": "לא ניתן ליצור את ההסכמה.",
  "patient.documents.issueFailed": "לא ניתן להנפיק את הקישור לחתימה.",
  "patient.documents.acceptFailed": "לא ניתן לאשר את ההסכמה.",
  "patient.documents.rejectFailed": "לא ניתן לדחות את ההסכמה.",
  "patient.documents.revokeFailed": "לא ניתן לבטל את ההסכמה.",
  "patient.documents.consentChanged": "ההסכמה השתנתה בזמן שהאזור היה פתוח. יש לרענן ולחזור על הפעולה.",
  "patient.documents.consentGone": "ההסכמה הזו אינה קיימת עוד. יש לרענן את האזור.",
  "patient.documents.consentUnavailable": "שירות ההסכמות לא נענה. יש לנסות שוב בהמשך.",
  "patient.documents.consentRequestInvalid": "הבקשה נדחתה. יש לבדוק את השפה ואת הסיבה.",
  "patient.documents.consentAlreadyActive": "למטופל יש כבר הסכמה בתוקף מסוג זה.",
  "patient.documents.consentNotPending": "ניתן להנפיק קישור רק להסכמה הממתינה לחתימה.",
  "patient.documents.consentNotSubmitted": "ניתן לאשר או לדחות רק הסכמה שהוגשה.",
  "patient.documents.consentNotRevocable": "ההסכמה הזו כבר בוטלה או נדחתה.",
  "patient.documents.consentAccepted": "אושרה",
  "patient.documents.consentMissing": "לא אושרה",
  "patient.documents.consentLanguage": "שפת ההסכמה",
  "patient.documents.language.en": "אנגלית",
  "patient.documents.language.he": "עברית",
  "patient.documents.language.ru": "רוסית",
  "patient.documents.createConsent": "יצירת הסכמה",
  "patient.documents.creating": "יוצר…",
  "patient.documents.downloadBlank": "הורדת טופס",
  "patient.documents.downloadSigned": "הורדת הסכמה חתומה",
  "patient.documents.linkReady": "קישור לחתימה",
  "patient.documents.accept": "אישור ההסכמה",
  "patient.documents.accepting": "מאשר…",
  "patient.documents.reject": "דחייה",
  "patient.documents.rejecting": "דוחה…",
  "patient.documents.rejectReason": "סיבת הדחייה",
  "patient.documents.rejectTitle": "לדחות את ההסכמה?",
  "patient.documents.revokeTitle": "לבטל את ההסכמה?",
  "patient.documents.rejectionReason": "סיבת הדחייה",
  "patient.documents.consentSection": "הסכמה לעיבוד מידע אישי",
  "patient.documents.governmentIds": "דרכונים ומסמכי זיהוי",
  // Every value opens with a Hebrew word, so the first strong character keeps
  // the line right-to-left inside `bdi`.
  "patient.documents.allGovernmentIdsExpired":
    "כל מסמכי הזיהוי כאן פגי תוקף.",
  "patient.documents.allInsuranceExpired": "כל הפוליסות כאן פגות תוקף.",
  "patient.documents.insurancePolicies": "פוליסות ביטוח",
  "patient.documents.addGovernmentId": "הוספת מסמך זיהוי",
  "patient.documents.addInsurance": "הוספת פוליסת ביטוח",
  "patient.documents.noGovernmentIds": "עדיין לא נרשמו מסמכי זיהוי.",
  "patient.documents.noInsurancePolicies": "עדיין לא נרשמו פוליסות ביטוח.",
  "patient.documents.downloadScan": "הורדת סריקה",
  "patient.documents.cancel": "ביטול",
  "patient.documents.source": "מקור המסמך",
  "patient.documents.source.upload": "העלאת סריקה חדשה",
  "patient.documents.source.existing": "שימוש בקובץ קיים",
  "patient.documents.pdfPage": "עמוד PDF",
  "patient.documents.scanEditor": "סריקת המסמך",
  "patient.documents.dropZone":
    "גררו סריקה לכאן, הדביקו אותה מהלוח או בחרו קובץ.",
  "patient.documents.dropZoneMore":
    "אפשר להוסיף את שני צידי הכרטיס או כמה עמודי דרכון כתמונות נפרדות; הם יישמרו כמסמך אחד.",
  "patient.documents.chooseFiles": "בחירת קבצים",
  "patient.documents.addPage": "הוספת עמוד נוסף",
  "patient.documents.pages": "עמודי המסמך",
  "patient.documents.pageName": "עמוד {index}",
  "patient.documents.rotateLeft": "סיבוב שמאלה",
  "patient.documents.rotateRight": "סיבוב ימינה",
  "patient.documents.cropPage": "חיתוך",
  "patient.documents.cropReset": "איפוס החיתוך",
  "patient.documents.cropMove": "הזזת מסגרת החיתוך",
  "patient.documents.cropEdge.left": "הקצה השמאלי של החיתוך",
  "patient.documents.cropEdge.top": "הקצה העליון של החיתוך",
  "patient.documents.cropEdge.right": "הקצה הימני של החיתוך",
  "patient.documents.cropEdge.bottom": "הקצה התחתון של החיתוך",
  "patient.documents.cropCorner.topLeft": "הפינה השמאלית העליונה של החיתוך",
  "patient.documents.cropCorner.topRight": "הפינה הימנית העליונה של החיתוך",
  "patient.documents.cropCorner.bottomLeft": "הפינה השמאלית התחתונה של החיתוך",
  "patient.documents.cropCorner.bottomRight": "הפינה הימנית התחתונה של החיתוך",
  "patient.documents.removePage": "הסרת עמוד {index}",
  "patient.documents.movePageEarlier": "העברת עמוד {index} קדימה",
  "patient.documents.movePageLater": "העברת עמוד {index} אחורה",
  "patient.documents.pagesMerged":
    "העמודים נשמרים כקבצים נפרדים בסדר הזה. כל הקבצים נכללים בזיהוי.",
  "patient.documents.pagePreparing": "מכין את העמוד…",
  "patient.documents.pageFailed":
    "הדפדפן לא הצליח להכין את העמוד. הוא יועלה כקובץ המקורי.",
  "patient.documents.unsupportedFiles": "אפשר להוסיף רק תמונות וקובצי PDF.",
  "patient.documents.existingFile": "קובץ מטופל קיים",
  "patient.documents.selectExisting": "בחירת קובץ",
  "patient.documents.saving": "שומר…",
  "patient.documents.saveDocument": "שמירת מסמך",
  "patient.documents.suggestFromScan": "הצעה מהסריקה",
  "patient.documents.suggesting": "קורא את הסריקה…",
  "patient.documents.suggestionApplied":
    "ההצעות מולאו בטופס. בדקו כל שדה לפני שמירה.",
  "patient.documents.suggestionReview":
    "ההצעות האוטומטיות הן טיוטה בלבד. בדקו את הסריקה וערכו את השדות לפני שמירה.",
  "patient.documents.recognitionUnavailable": "זיהוי מסמכים אינו זמין כרגע. נסו שוב מאוחר יותר או מלאו את השדות ידנית.",
  "patient.documents.suggestionFailed":
    "לא ניתן לקרוא את הסריקה אוטומטית. מלאו את השדות ידנית.",
  "patient.documents.suggestionWarning": "אזהרת מודל: {warning}",
  "patient.documents.previewEmpty": "בחרו סריקה כדי לבדוק אותה לצד הטופס.",
  "patient.documents.uploadTitle.governmentId": "מסמך זיהוי ממשלתי",
  "patient.documents.uploadTitle.insurance": "פוליסת ביטוח",
  "patient.documents.governmentId.type": "סוג המסמך",
  "patient.documents.governmentId.type.travel_passport": "דרכון לנסיעות",
  "patient.documents.governmentId.type.diplomatic_passport": "דרכון דיפלומטי",
  "patient.documents.governmentId.type.service_passport": "דרכון שירות",
  "patient.documents.governmentId.type.temporary_identity": "תעודת זהות זמנית",
  "patient.documents.governmentId.type.military_id": "תעודה צבאית",
  "patient.documents.governmentId.type.seafarer_id": "תעודת יורד ים",
  "patient.documents.governmentId.type.stateless_document": "מסמך לחסר אזרחות",
  "patient.documents.governmentId.type.refugee_document": "מסמך פליט או מקלט",
  "patient.documents.governmentId.type.snils": "מספר SNILS",
  "patient.documents.governmentId.type.tax_number": "מספר מס אישי",
  "patient.documents.documentSeries": "סדרה",
  "patient.documents.issuerCode": "קוד הרשות המנפיקה",
  "patient.documents.personalNumber": "מספר אישי",
  "patient.documents.designation": "שם המסמך",
  "patient.documents.governmentId.type.passport": "דרכון",
  "patient.documents.governmentId.type.national_id_card": "תעודת זהות",
  "patient.documents.governmentId.type.residence_permit": "אשרת/היתר תושבות",
  "patient.documents.governmentId.type.driving_licence": "רישיון נהיגה",
  "patient.documents.governmentId.type.birth_certificate": "תעודת לידה",
  "patient.documents.governmentId.type.other_government_id":
    "מסמך זיהוי ממשלתי אחר",
  "patient.documents.documentNumber": "מספר מסמך",
  "patient.documents.issuingCountry": "מדינת הנפקה",
  "patient.documents.nameOnDocument": "שם במסמך",
  "patient.documents.birthDate": "תאריך לידה",
  "patient.documents.issueDate": "תאריך הנפקה",
  "patient.documents.expiryDate": "תוקף עד",
  "patient.documents.issuingAuthority": "רשות מנפיקה",
  "patient.documents.insurance.type": "סוג הפוליסה",
  "patient.documents.insurance.type.israel_kupat_holim_basic":
    "כיסוי בסיסי בקופת חולים בישראל",
  "patient.documents.insurance.type.israel_shaban_supplementary": "שב״ן בישראל",
  "patient.documents.insurance.type.israel_private_commercial":
    "ביטוח פרטי מסחרי בישראל",
  "patient.documents.insurance.type.israel_tourist_travel":
    "ביטוח תיירים או נסיעות בישראל",
  "patient.documents.insurance.type.israel_student": "ביטוח סטודנטים בישראל",
  "patient.documents.insurance.type.israel_foreign_worker":
    "ביטוח עובד זר בישראל",
  "patient.documents.insurance.type.israel_international_private":
    "ביטוח פרטי בינלאומי בישראל",
  "patient.documents.insurance.type.statutory_public_health":
    "כיסוי בריאות ציבורי סטטוטורי",
  "patient.documents.insurance.type.social_health_fund": "קופת בריאות חברתית",
  "patient.documents.insurance.type.supplementary_health_plan":
    "תוכנית בריאות משלימה",
  "patient.documents.insurance.type.commercial_private_health":
    "ביטוח בריאות פרטי מסחרי",
  "patient.documents.insurance.type.employer_group_health":
    "תוכנית בריאות קבוצתית של מעסיק",
  "patient.documents.insurance.type.travel_health": "ביטוח בריאות לנסיעות",
  "patient.documents.insurance.type.student_health": "ביטוח בריאות לסטודנטים",
  "patient.documents.insurance.type.foreign_worker_health":
    "ביטוח בריאות לעובד זר",
  "patient.documents.insurance.type.international_expat_health":
    "ביטוח בריאות בינלאומי או לרילוקיישן",
  "patient.documents.insurance.type.other_health_coverage": "כיסוי בריאות אחר",
  "patient.documents.insurerName": "מבטח",
  "patient.documents.planName": "שם תוכנית",
  "patient.documents.policyNumber": "מספר פוליסה",
  "patient.documents.memberNumber": "מספר חבר",
  "patient.documents.groupNumber": "מספר קבוצה",
  "patient.documents.validFrom": "בתוקף מ",
  "patient.documents.validTo": "בתוקף עד",
  "patient.documents.status.prepared": "הוכן",
  "patient.documents.status.sent": "ממתין לחתימה",
  "patient.documents.status.submitted": "הועלה וממתין לבדיקת המרפאה",
  "patient.documents.status.accepted": "אושר",
  "patient.documents.status.rejected": "נדחה",
  "patient.documents.status.revoked": "בוטל",
  "patient.documents.public.title": "חתימת מסמך מטופל",
  "medicalSheet.title": "דף כותרת רפואי",
  "medicalSheet.subtitle":
    "התיק במבט אחד: אבחנות, מדדים אחרונים ועבודה פתוחה, מתוך הסעיפים שבבעלותם",
  "medicalSheet.loading": "קורא את התיק…",
  "medicalSheet.notReadable": "לא זמין לחשבון זה",
  "medicalSheet.recordsForbidden":
    "חשבון זה אינו יכול לקרוא רשומות קליניות, ולכן חלק זה של הדף אינו מוצג.",
  "medicalSheet.statPatient": "מטופל",
  "medicalSheet.ageUnknown": "גיל לא נרשם",
  "medicalSheet.curatorNamed": "מלווה: {name}",
  "medicalSheet.curatorNone": "לא הוגדר מלווה",
  "medicalSheet.statDiagnoses": "אבחנות פעילות",
  "medicalSheet.diagnosesCaption": "{total} ברשומה · {chronic} כרוניות",
  "medicalSheet.statCases": "תיקים פתוחים",
  "medicalSheet.casesCaption": "פעילים ומתוכננים",
  "medicalSheet.statStay": "אשפוז",
  "medicalSheet.stayNone": "אין",
  "medicalSheet.stayNoneCaption": "אין אשפוז נוכחי או מתוכנן",
  "medicalSheet.statLastVisit": "מפגש אחרון",
  "medicalSheet.visitNone": "אין",
  "medicalSheet.visitNoneCaption": "לא נרשמו מפגשים",
  "medicalSheet.statLaboratory": "תוצאות מחוץ לטווח",
  "medicalSheet.laboratoryWindow": "90 הימים האחרונים",
  "medicalSheet.laboratoryCritical": "{count} קריטיות · 90 הימים האחרונים",
  "medicalSheet.laboratoryClear": "אין חריגות",
  "medicalSheet.laboratoryNoResults": "אין תוצאות עדיין",
  "medicalSheet.diagnosesTitle": "אבחנות",
  "medicalSheet.diagnosesEmpty": "לא נרשמו אבחנות למטופל זה.",
  "medicalSheet.diagnosesFailed": "לא ניתן לקרוא את האבחנות.",
  "medicalSheet.encounters": "מפגשים",
  "medicalSheet.vitalsTitle": "סימנים חיוניים אחרונים",
  "medicalSheet.vitalsEmpty": "לא נרשמו סימנים חיוניים.",
  "medicalSheet.vitalsFailed": "לא ניתן לקרוא את הסימנים החיוניים.",
  "medicalSheet.laboratoryTitle": "תוצאות הדורשות תשומת לב",
  "medicalSheet.laboratoryEmpty": "אין תוצאות מעבדה מחוץ לטווח.",
  "medicalSheet.laboratoryFailed": "לא ניתן לקרוא את תוצאות המעבדה.",
  "medicalSheet.casesTitle": "תיקים פתוחים",
  "medicalSheet.casesEmpty": "אין תיקים פתוחים.",
  "medicalSheet.casesFailed": "לא ניתן לקרוא את התיקים.",
  "medicalSheet.staysTitle": "אשפוזים",
  "medicalSheet.staysEmpty": "אין אשפוז נוכחי או מתוכנן.",
  "medicalSheet.staysFailed": "לא ניתן לקרוא את האשפוזים.",
  "medicalSheet.encountersTitle": "מפגשים אחרונים",
  "medicalSheet.encountersEmpty": "לא נרשמו מפגשים.",
  "medicalSheet.encountersFailed": "לא ניתן לקרוא את המפגשים.",
  "medicalSheet.filesTitle": "מסמכים אחרונים",
  "medicalSheet.filesEmpty": "אין מסמכים מצורפים.",
  "medicalSheet.filesFailed": "לא ניתן לקרוא את המסמכים.",
  "medicalSheet.openRecords": "כל המפגשים",
  "medicalSheet.openLaboratory": "כל התוצאות",
  "medicalSheet.openCases": "כל התיקים",
  "medicalSheet.openStays": "כל האשפוזים",
  "medicalSheet.openFiles": "כל הקבצים",
  "medicalSheet.undated": "ללא תאריך",
  "medicalSheet.referenceRange": "טווח ייחוס: {range}",
  "case.loading": "טוען תיקים",
  "case.loadFailed": "לא ניתן לטעון את התיקים.",
  "case.datesOutOfOrder": "תאריך הסיום מוקדם מתאריך ההתחלה.",
  "case.staleRevision":
    "התיק שונה במקום אחר. טען אותו מחדש כדי לראות מה מאוחסן כעת, ולאחר מכן החל עליו את השינוי שלך.",
  "case.transitionRefused": "התיק כבר אינו בסטטוס המאפשר זאת.",
  "case.saveFailed": "לא ניתן לשמור את התיק. נסה שוב.",
  "case.gone": "התיק אינו זמין עוד.",
  "case.unavailable": "התיקים אינם זמינים כרגע.",
  "case.status.planned": "מתוכנן",
  "case.status.active": "פעיל",
  "case.status.completed": "הושלם",
  "case.status.cancelled": "בוטל",
  "case.sectionTitle": "תיקים",
  "case.sectionSubtitle":
    "כל התיקים הרשומים למטופל זה. תיק הוא פרק טיפול: הוא מאגד את המפגשים, הרשומות וההפניות השייכים לו.",
  "case.empty": "לא נרשמו תיקים",
  "case.emptyDetail":
    "עדיין לא נרשמה עבודה קלינית עבור מטופל זה. המפגש או רשומת ה-EMR הראשונים יפתחו את התיק הראשון.",
  "case.noMatches": "אין תיק התואם את הסינון הנוכחי",
  "case.columnTitle": "תיק",
  "case.columnCode": "קוד",
  "case.columnCurator": "אחראי",
  "case.columnStatus": "סטטוס",
  "case.columnPeriod": "תקופה",
  "case.columnColour": "צבע",
  "case.columnActions": "פעולות",
  "case.noPeriod": "ללא תאריכים",
  "case.transitionOn": "{action}: {title}",
  "case.periodRange": "{from} – {to}",
  "case.periodFrom": "מ־{from}",
  "case.periodUntil": "עד {to}",
  "case.new": "תיק חדש",
  "case.edit": "עריכת תיק",
  "case.editNamed": "עריכת תיק {name}",
  "case.openNamed": "פתיחת תיק {name}",
  "case.title": "כותרת",
  "case.comment": "הערה",
  "case.startDate": "תאריך התחלה",
  "case.endDate": "תאריך סיום",
  "case.create": "יצירת תיק",
  "case.save": "שמירת התיק",
  "case.titleRequired": "לתיק דרושה כותרת.",
  "case.reload": "טעינת התיק מחדש",
  "case.reloaded": "נטען מחדש מהשרת. יש לבדוק את השינויים ולשמור שוב.",
  "case.reloadFailed":
    "לא ניתן היה לטעון את הגרסה השמורה. השינויים שלך עדיין כאן.",
  "case.unsavedIntent": "פרטי תיק",
  "case.activate": "הפעלה",
  "case.complete": "השלמה",
  "case.cancelCase": "ביטול התיק",
  "case.colour": "צבע",
  "case.colourNone": "ללא צבע",
  "case.colour.red": "אדום",
  "case.colour.orange": "כתום",
  "case.colour.green": "ירוק",
  "case.colour.teal": "טורקיז",
  "case.colour.blue": "כחול",
  "case.colour.purple": "סגול",
  "stay.sectionTitle": "אשפוזים",
  "stay.independent": "אשפוזים עומדים בפני עצמם. הם אינם מקובצים תחת תיקים.",
  "stay.loading": "טוען אשפוזים…",
  "stay.loadFailed": "לא ניתן היה לטעון את האשפוזים.",
  "stay.empty": "לא תועדו אשפוזים",
  "stay.emptyDetail": "לא מצופה כאן דבר. אשפוז מתועד רק כאשר הוא מתוכנן.",
  "stay.new": "תכנון אשפוז",
  "stay.create": "יצירת אשפוז",
  "stay.save": "שמירת אשפוז",
  "stay.cancelEditor": "ביטול שינויים",
  "stay.unsavedIntent": "תוכנית אשפוז",
  "stay.editNamed": "עריכת תכנון האשפוז ב{facility}",
  "stay.transitionOn": "{action}: {facility}",
  "stay.facility": "מוסד רפואי",
  "stay.facilityRequired": "יש לציין את המוסד לפני השמירה.",
  "stay.wardBedNote": "הערת מחלקה או מיטה (לא חובה)",
  "stay.plannedAdmission": "קבלה מתוכננת (שעון המרפאה)",
  "stay.plannedDischarge": "שחרור מתוכנן (שעון המרפאה)",
  "stay.timesRequired": "יש להזין את שני הזמנים המתוכננים לפני השמירה.",
  "stay.timesOutOfOrder": "השחרור המתוכנן חייב להיות אחרי הקבלה המתוכננת.",
  "stay.plannedWindow": "מתוכנן:",
  "stay.actualAdmission": "התקבל:",
  "stay.actualDischarge": "שוחרר:",
  "stay.admit": "קבלה לאשפוז",
  "stay.discharge": "שחרור",
  "stay.cancelStay": "ביטול אשפוז",
  "stay.status.planned": "מתוכנן",
  "stay.status.admitted": "מאושפז",
  "stay.status.discharged": "שוחרר",
  "stay.status.cancelled": "בוטל",
  "stay.staleRevision":
    "האשפוז שונה במקום אחר. טען אותו מחדש לפני ביצוע פעולה.",
  "stay.reload": "טעינת האשפוז מחדש",
  "stay.reloaded": "נטען מחדש מהשרת. יש לבדוק את האשפוז ולנסות שוב.",
  "stay.reloadFailed":
    "לא ניתן היה לטעון את הגרסה השמורה. השינויים שלך עדיין כאן.",
  "stay.transitionRefused": "האשפוז כבר אינו במצב המאפשר פעולה זו.",
  "stay.gone": "האשפוז אינו זמין עוד.",
  "stay.unavailable": "האשפוזים אינם זמינים כעת. נסה שוב.",
  "stay.saveFailed": "לא ניתן היה לשמור את האשפוז. נסה שוב.",
};
